import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Stop } from '../../../../models/manager-content-vehicle-history-drawer.model';
import { AsideHistoryCard } from '../../models/content-vehicle-history-drawer.model';

@Component({
  selector: 'stops-history-list',
  templateUrl: './stops-history-list.component.html',
  styleUrls: ['./stops-history-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StopsHistoryListComponent {
  @Input() stops: AsideHistoryCard<'stops'>[] = [];
  @Input() currentImei: string = '';
  @Input() currentState: Map<string, Map<string, boolean>> = new Map();
  @Output() selectCard = new EventEmitter<any>();
  @Output() redirectTo = new EventEmitter<string>();

  readonly itemSize = 80; // Altura fija para stops

  isCardSelected(id: number, type: string, variant: string = 'stop'): boolean {
    const currentImei = this.currentImei;
    if (!currentImei) return false;

    const imeiMap = this.currentState.get(currentImei);
    if (!imeiMap) return false;

    const key = `${id}-${type}-${variant}`;
    return imeiMap.get(key) ?? false;
  }

  trackByStopId(_index: number, stop: AsideHistoryCard<'stops'>) {
    return `${stop.id}-${stop.type}-${stop.variant}`;
  }

  onSelectCard(event: any): void {
    this.selectCard.emit(event);
  }

  onRedirectTo(type: string): void {
    this.redirectTo.emit(type);
  }

  get isEmpty(): boolean {
    return !this.stops || this.stops.length === 0;
  }

  get emptyMessage(): string {
    return 'No hay paradas registradas en este período de tiempo';
  }

  get suggestionMessage(): string {
    return '¿Te gustaría revisar los frames o eventos del vehículo?';
  }
}
